import React, { useEffect, useState } from 'react';

import Dialog from '../../../../../../../reusables/Dialog';
import DialogExtraCaption from '../../../../../../../reusables/Dialog/extras/caption';
import ReusableList from '../../../../../../../reusables/List';

interface IProps {
  currentData: any;
  isVirtual: boolean;
  previusData: any;
  show: boolean;
  handlerClose: () => void;
  handlerOnNext: () => void;
}

const DialogExchangeOptions = ({
  currentData,
  isVirtual,
  previusData,
  show,
  handlerOnNext,
  handlerClose
}: IProps) => {
  const [currentItems, setCurrentItems] = useState<string[]>([]);
  const [previusItems, setPreviusItems] = useState<string[]>([]);

  useEffect(() => {}, [currentData]);
  useEffect(() => {
    if (currentData) {
      const data: string[] = [];

      if (previusData?.campus?.id !== currentData?.campus?.id)
        data.push(`Campus: ${currentData?.campus?.name?.toUpperCase()}`);
      if (previusData?.grouping?.id !== currentData?.program?.id)
        data.push(`Carrera: ${currentData?.program?.name?.toUpperCase()}`);
      if (
        previusData?.studiesOption?.modalityCode !== currentData?.modality?.id
      )
        data.push(`Modalidad: ${currentData?.modality?.name?.toUpperCase()}`);

      setCurrentItems(data);
    }

    if (previusData) {
      const data: string[] = [];

      if (!isVirtual)
        data.push(`Campus: ${previusData?.campus?.name?.toUpperCase()}`);
      data.push(`Carrera: ${previusData?.program?.name?.toUpperCase()}`);
      data.push(
        `Modalidad: ${previusData?.studiesOption?.modalityName?.toUpperCase()}`
      );

      setPreviusItems(data);
    }
  }, [currentData, previusData]);

  return (
    <Dialog
      handlerClose={() => handlerClose()}
      maxWidth="400px"
      show={show}
      zIndex={1000}
      textButtonA="Sí, solicitar"
      handlerButtonA={() => handlerOnNext()}
      textButtonB="Cancelar"
      handlerButtonB={() => handlerClose()}
    >
      <DialogExtraCaption title="Opciones de cambio" />
      <div style={{ padding: '16px 32px 0 32px' }}>
        <p>Actualmente te encuentras en:</p>
        <ReusableList items={previusItems} />
        <br />
        {currentItems.length > 0 && (
          <>
            <p>Tus cambios solicitados:</p>
            <ReusableList items={currentItems} />
          </>
        )}
      </div>
    </Dialog>
  );
};

export default DialogExchangeOptions;
